<template>
  <div class="container no-padding-container text-gray-600">
    <div class="px-5">
      <div class="pt-5 md:pt-12 pb-12">
        <h1 class="ota-title mb-3 text-center md:mb-10" v-text="$t('TermsOfUse.Content.Title')" />
        <p class="ota-body-light" v-html="$t('TermsOfUse.Content.Description')" />
      </div>
      <TermsOfUseComponent />
    </div>
  </div>
</template>

<script>
import TermsOfUseComponent from '@/components/TermsOfUseComponent'

export default {
  name: 'TermsOfUse',
  layout: 'homepage',
  components: { TermsOfUseComponent },
  head () {
    return {
      title: this.$t('TermsOfUse.PageTitle'),
      meta: [
        {
          hid: 'og:description',
          name: 'og:description',
          property: 'og:description',
          content: this.$t('TermsOfUse.Description')
        }
      ]
    }
  }
}
</script>

<style lang="postcss" scoped>
.product-accordion {
  >>> b {
    @apply font-extrabold;
  }

  >>> .ota-p18 {
    font-size: 1.5rem;
  }
}

.right-flex {
  max-width: 75rem;
}
</style>
